import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccessResult, hasAdminAccess, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

type ScanForDelete = {
  space: { id: string };
};

const useCanDeleteScan = (): ((scan?: ScanForDelete) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (scan?: ScanForDelete) => {
      if (!scan) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      if (hasAdminAccess(viewer, scan.space.id)) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanDeleteScan;
